<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'
	import next from 'array-next'
	import lozad from 'lozad'
	import gsap from 'gsap'

	//array
	export let hero
	let video = hero.hero_video
	const { videoPoster } = window.modal_object
	let pattern = /(\\|\")/g
	// if (video.length) {
	// 	video = video.replaceAll(pattern, '')
	// }
	let images = hero.hero_images
	let buttonText = hero.button_text
	let buttonUrl = hero.button_url
	let states = [
		[hero.video_header_1, hero.video_sub_header_1],
		[hero.video_header_2, hero.video_sub_header_2],
		[hero.video_header_3, hero.video_sub_header_3],
	]

	let activeImage = images[0]
	let activeState = states[0]
	let observer
	let status = ''
	let onLoad = false

	const tl = gsap.timeline()

	//const preloadImages = (activeImage) => {
	//	return {
	//		update() {
	//			// load images in front and behind active image
	//			let nextImage = next(images, activeImage)
	//			let prevImage = prev(images, activeImage)
	//			loadImages([nextImage, prevImage])
	//		},
	//	}
	//}

	let slideint
	function getImage() {
		activeImage = next(images, activeImage)
		if (images.indexOf(activeImage) % 2 == 0)
			activeState = next(states, activeState)
	}

	onMount(() => {
		// lazy load images
		observer = lozad()
		observer.observe()
		setTimeout(() => (onLoad = true), 25)

		// setTimeout(() => (lineWidth = 10), 100)
		//set transition
		//slideint = setInterval(getImage, 3000)

		//Animation
		setTimeout(() => {
			//item 1
			tl.to('#home-hero-item-1 > h2', { duration: 0.75, opacity: 1 })
			tl.to('#home-hero-item-1 > p', { duration: 0.75, opacity: 1 })
			tl.from('#home-hero-bg-word-1', { duration: 0.5, opacity: 1 })
			tl.to('#home-hero-line-1 > span', { duration: 0.25, width: 100 })
			//item 2
			tl.to('#home-hero-item-2 > h2', { duration: 0.75, opacity: 1 })
			tl.to('#home-hero-item-2 > p', { duration: 0.75, opacity: 1 })
			tl.to('#home-hero-bg-word-1', { duration: 0.5, opacity: 0 }, '-=1.75')
			tl.to('#home-hero-bg-word-2', { duration: 0.5, opacity: 1 }, '-=2')
			tl.to('#home-hero-line-2 > span', { duration: 0.25, width: 100 })
			//item 3
			tl.to('#home-hero-item-3 > h2', { duration: 0.75, opacity: 1 })
			tl.to('#home-hero-item-3 > p', { duration: 0.75, opacity: 1 })
			tl.to('#home-hero-bg-word-2', { duration: 0.5, opacity: 0 }, '-=2.25')
			tl.to('#home-hero-bg-word-3', { duration: 0.5, opacity: 1 }, '-=2')
		}, 1500)
	})
</script>

<style>
	div {
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}
	li:last-child {
		margin-right: 0;
	}
</style>

<section id="home-hero" class="section-full">
	{#if video}
		<div class="bg-video">
			<video playsinline autoplay loop muted poster={videoPoster}>
				<source src={video} />
			</video>
			<span />
		</div>
	{:else}
		{#each [activeImage] as src (src)}
			<div
				class="hp-slide bg-img"
				style="background-image:url({src})"
				in:fade={{ duration: 700, easing: sineInOut }}
				out:fade={{ duration: 650, easing: sineInOut, delay: 200 }} />
		{/each}
	{/if}
	<div class="home-hero-big-word-wrap">
		<div class="home-hero-bg-word" id="home-hero-bg-word-1">{states[0][0]}</div>
		<div class="home-hero-bg-word" id="home-hero-bg-word-2">{states[1][0]}</div>
		<div class="home-hero-bg-word" id="home-hero-bg-word-3">{states[2][0]}</div>
	</div>
	<div class="main">
		<div class="inner-wrap">
			<ul>
				<li id="home-hero-item-1">
					<h2>{states[0][0]}</h2>
					<p>{states[0][1]}</p>
				</li>
				<li id="home-hero-line-1" class="home-hero-line">
					<span />
				</li>
				<li id="home-hero-item-2">
					<h2>{states[1][0]}</h2>
					<p>{states[1][1]}</p>
				</li>
				<li id="home-hero-line-2" class="home-hero-line">
					<span />
				</li>
				<li id="home-hero-item-3">
					<h2>{states[2][0]}</h2>
					<p>{states[2][1]}</p>
				</li>
			</ul>
			{#if buttonUrl && onLoad}
				<a
					class="btn"
					href={buttonUrl}
					in:fly={{ y: 50, duration: 800, delay: 7000, easing: sineInOut }}
					out:fly={{ y: 50, duration: 800, easing: sineInOut }}>
					<span>
						{@html buttonText}
					</span>
					<div>
						<svg x="0px" y="0px" viewBox="0 0 100 125">
							<g transform="translate(0,-952.36218)">
								<path
									style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;"
									d="m 71.35934,1002.3622 -4.25,-4.25004 -29.99998,-30
									-8.4687,8.5 25.74993,25.75004 -25.74993,25.75 8.4687,8.5
									29.99998,-30 4.25,-4.25 z"
									fill="#000000"
									fill-opacity="1"
									stroke="none"
									marker="none"
									visibility="visible"
									display="inline"
									overflow="visible" />
							</g>
						</svg>
					</div>
				</a>
			{/if}
		</div>
	</div>
	{#if onLoad}
		<div
			class="hero-square red-square"
			in:fade={{ duration: 800, delay: 200, easing: sineInOut }}
			out:fade={{ duration: 800, easing: sineInOut }} />
		<div
			class="hero-square orange-square"
			in:fade={{ duration: 800, delay: 400, easing: sineInOut }}
			out:fade={{ duration: 800, easing: sineInOut }} />
		<div
			class="hero-square yellow-square"
			in:fade={{ duration: 800, delay: 600, easing: sineInOut }}
			out:fade={{ duration: 800, easing: sineInOut }} />
	{/if}
</section>
